module.exports = __webpack_public_path__ + "img/icons B_2.32022adc.svg";